import {
  BitResponse,
  BlessingResponse,
  CreateGiftCardsOrderModel,
  CreateGroupPurchaseRequest,
} from "api"

export type PaymentData = {
  expirationTime?: number
  paymentData: BitResponse
  purchaseData: CreateGiftCardsOrderModel
  selectedGiftCard: BlessingResponse
  blessingMode: string
  giftCardLoadAmount: number
  orderId: number
  orderRecipientGuid: string
  giftCardPrice: number
  addPercentage: number
}

const PAYMENT_EXPIRATION_TIME = 15 * 60 * 1000 // 15 minutes in milliseconds

export const savePaymentDataToLocalStorage = (
  orderRecipientGuid,
  data: PaymentData
) => {
  const expirationTime = new Date().getTime() + PAYMENT_EXPIRATION_TIME
  const storageData: PaymentData = {
    ...data,
    expirationTime: expirationTime,
  }
  localStorage.setItem(orderRecipientGuid, JSON.stringify(storageData))
}

export type GroupPurchasePaymentData = {
  expirationTime?: number
  paymentData: BitResponse
  groupPurchaseData: CreateGroupPurchaseRequest
  orderId: number
  groupPurchaseUserGuid: string
  giftCardPrice: number
}

export const saveGroupPurchasePaymentDataToLocalStorage = (
  groupPurchaseUserGuid,
  data: GroupPurchasePaymentData
) => {
  const expirationTime = new Date().getTime() + PAYMENT_EXPIRATION_TIME
  const storageData: GroupPurchasePaymentData = {
    ...data,
    expirationTime: expirationTime,
  }
  localStorage.setItem(groupPurchaseUserGuid, JSON.stringify(storageData))
}

export const getPaymentDataFromLocalStorage = (
  orderRecipientGuid
): PaymentData =>
  JSON.parse(localStorage.getItem(orderRecipientGuid)) as PaymentData

type loadBitComParams = {
  isDesktop: boolean
  orderRecipientGuid?: string
  groupPurchaseUserGuid?: string
  paymentInitiationId: string
  transactionSerialId: string
  isAndroid: boolean
  isIOS: boolean
  pay: (transactionSerialId: string, paymentInitiationId: string) => void
}

export const loadBitCom = ({
  isDesktop,
  orderRecipientGuid,
  groupPurchaseUserGuid,
  paymentInitiationId,
  isAndroid,
  isIOS,
  transactionSerialId,
  pay,
}: loadBitComParams) => {
  if (isDesktop) {
    if (window.scriptEl) {
      pay(transactionSerialId, paymentInitiationId)
    } else {
      const scriptEl = document.createElement("script")
      scriptEl.src = "https://public.bankhapoalim.co.il/bitcom/sdk"
      scriptEl.onload = function () {
        pay(transactionSerialId, paymentInitiationId)
      }
      document.head.appendChild(scriptEl)
      window.scriptEl = scriptEl
    }
  } else {
    const storageData = JSON.parse(
      localStorage.getItem(orderRecipientGuid || groupPurchaseUserGuid)
    )
    const origin = location?.origin
    const encodedReturnScheme = `%26return_scheme%3D${encodeURIComponent(
      encodeURIComponent(
        `${origin}/payment/bit?orderguid=${
          orderRecipientGuid || groupPurchaseUserGuid
        }&paymentinitiaionid=${paymentInitiationId}`
      )
    )}`
    if (storageData) {
      if (isAndroid) {
        const url = `${storageData.paymentData.applicationSchemeAndroid}${encodedReturnScheme}`
        location.href = url
      }
      if (isIOS) {
        const url = `${storageData.paymentData.applicationSchemeIos}${encodedReturnScheme}`
        location.href = url
      }
    }
  }
}

type bitPayParams = {
  transactionSerialId: string
  paymentInitiationId: string
  onApproval: () => void
  onCancel: () => void
}
export const bitPay = ({
  transactionSerialId,
  paymentInitiationId,
  onApproval,
  onCancel,
}: bitPayParams) => {
  if (window.BitPayment) {
    window.BitPayment.pay({
      transactionSerialId: transactionSerialId,
      paymentInitiationId: paymentInitiationId,
      env: "Prod",
      onApproved: function () {
        onApproval()
      },
      onCancel: function () {
        onCancel()
      },
      onTimeout: function () {
        onCancel()
      },
    })
  }
}
